var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgEmptyStateDocuments = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 400,
    height: 260,
    viewBox: "0 0 400 260",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.0049 156.933C65.3434 150.562 94.5249 148.249 114.919 164.492C125.782 173.145 130.522 186.022 142.603 193.394C161.717 205.073 177.361 182.118 189.618 172.319C198.354 165.338 204.209 169.779 205.726 181.437C208.494 202.677 229.869 192.579 241.589 184.844L241.703 177.224C240.835 177.833 224.107 190.369 217.034 186.486C213.316 184.442 212.676 177.296 211.633 172.226C209.382 161.342 199.459 155.797 187.429 164.099C177.268 171.111 157.762 199.435 142.448 182.005C131.152 169.159 126.556 156.344 109.911 147.547C85.2624 134.525 54.1706 139.441 27.8391 145.791",
    stroke: "black",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.8673 200.117C39.2287 198.578 38.2787 197.039 36.7401 196.678C35.2016 196.317 33.663 197.267 33.3016 198.805C32.9402 200.344 33.8901 201.882 35.4287 202.244C36.9673 202.605 38.5059 201.655 38.8673 200.117Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M336.258 137.128C336.62 135.589 335.67 134.05 334.131 133.689C332.592 133.328 331.054 134.278 330.692 135.816C330.331 137.355 331.281 138.893 332.82 139.255C334.358 139.616 335.897 138.666 336.258 137.128Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M97.561 112.17C89.4137 114.132 87.4621 116.569 86.0784 127.731C85.9958 128.382 85.0561 128.382 84.9735 127.731C83.5898 116.569 81.6382 114.132 73.4909 112.17C72.923 112.035 72.923 111.22 73.4909 111.085C81.6382 109.123 83.5898 106.687 84.9735 95.524C85.0561 94.8735 85.9958 94.8735 86.0784 95.524C87.4621 106.687 89.4137 109.123 97.561 111.085C98.1289 111.22 98.1289 112.035 97.561 112.17Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M343.838 186.817C340.451 187.312 334.761 184.886 329.474 180.404C324.187 175.923 320.852 170.718 320.78 167.29C324.167 166.805 329.856 169.221 335.143 173.703C340.43 178.184 343.755 183.389 343.838 186.817Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M346.111 185.71C348.51 182.877 344.95 175.92 338.16 170.172C331.37 164.423 323.921 162.06 321.522 164.894C319.123 167.728 322.683 174.685 329.473 180.433C336.264 186.181 343.713 188.544 346.111 185.71Z",
    stroke: "black",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M320.769 167.29C324.156 166.794 329.846 169.221 335.143 173.702C340.44 178.184 343.765 183.388 343.837 186.817",
    stroke: "black",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M345.438 186.466L329.01 205.879C326.614 208.708 319.169 206.354 312.374 200.602C305.59 194.861 302.027 187.901 304.423 185.072L320.852 165.659",
    stroke: "black",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M307.955 180.9C307.118 180.621 306.323 180.187 305.601 179.578C302.606 177.038 302.234 172.556 304.764 169.551C307.294 166.547 311.786 166.185 314.791 168.715C315.503 169.324 316.071 170.037 316.484 170.811",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M39.7369 36.2692L38.5161 37.5733C37.6469 38.5017 37.695 39.959 38.6235 40.8281L72.0642 72.1323C72.9926 73.0014 74.4498 72.9533 75.3189 72.0249L76.5398 70.7207C77.4089 69.7923 77.3608 68.3351 76.4324 67.466L42.9917 36.1618C42.0632 35.2926 40.606 35.3407 39.7369 36.2692Z",
    stroke: "black",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M48.4086 54.3749L37.5869 44.245C37.1635 43.8423 37.1325 43.1711 37.5352 42.7374L38.9912 41.1885",
    stroke: "black",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M37.9176 38.214L35.3877 35.839C35.0469 35.5189 35.0263 34.9716 35.3464 34.6205L36.5855 33.2988C36.9056 32.958 37.4529 32.9374 37.7937 33.2575L40.3235 35.6325",
    fill: "black"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M37.9176 38.214L35.3877 35.839C35.0469 35.5189 35.0263 34.9716 35.3464 34.6205L36.5855 33.2988C36.9056 32.958 37.4529 32.9374 37.7937 33.2575L40.3235 35.6325",
    stroke: "black",
    strokeWidth: 2.5,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M79.1389 75.3258L73.408 74.035L78.4264 68.6758L80.0889 74.3138C80.2645 74.9024 79.7378 75.46 79.1389 75.3258Z",
    fill: "black"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M256.273 60.8903C255.137 66.0223 250.067 69.2544 244.945 68.1185C239.813 66.9827 236.581 61.9125 237.717 56.7805C238.047 55.2935 238.708 53.9511 239.617 52.8462C241.806 50.1408 245.42 48.7571 249.044 49.5522C253.464 50.5332 256.479 54.4468 256.489 58.8044C256.489 59.4962 256.417 60.1881 256.262 60.8903H256.273Z",
    stroke: "black",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M256.459 57.8958C256.779 57.8751 257.099 57.8958 257.429 57.9681C259.247 58.3708 260.393 60.1675 259.99 61.9849C259.587 63.8023 257.791 64.9485 255.973 64.5458C255.581 64.4632 255.23 64.3083 254.91 64.1121",
    fill: "black"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M256.459 57.8958C256.779 57.8751 257.099 57.8958 257.429 57.9681C259.247 58.3708 260.393 60.1675 259.99 61.9849C259.587 63.8023 257.791 64.9485 255.973 64.5458C255.581 64.4632 255.23 64.3083 254.91 64.1121",
    stroke: "black",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M237.5 58.5355C237.076 58.6078 236.643 58.6078 236.199 58.5045C234.381 58.1018 233.235 56.2948 233.638 54.4774C234.04 52.66 235.847 51.5138 237.665 51.9165C238.408 52.0817 239.038 52.4844 239.503 53.0214",
    fill: "black"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M237.5 58.5355C237.076 58.6078 236.643 58.6078 236.199 58.5045C234.381 58.1018 233.235 56.2948 233.638 54.4774C234.04 52.66 235.847 51.5138 237.665 51.9165C238.408 52.0817 239.038 52.4844 239.503 53.0214",
    stroke: "black",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M251.295 61.9951C247.97 62.8728 245.761 62.4907 244.232 61.7679C241.165 60.3223 241.031 56.0989 241.031 56.0989C241.031 56.0989 244.47 54.1886 247.475 55.5723C251.264 57.3277 251.295 61.9951 251.295 61.9951Z",
    stroke: "black",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M244.594 61.2928C244.212 59.3928 244.212 58.6184 244.801 57.6477C245.812 55.9749 247.568 55.8613 247.568 55.8613C247.568 55.8613 248.497 57.4412 247.702 59.1863C246.711 61.3858 244.594 61.2825 244.594 61.2825V61.2928Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M291.113 123.383C290.999 126.192 290.566 129.001 289.791 131.778C283.255 155.219 254.765 167.755 226.183 159.772C197.59 151.801 179.725 126.326 186.262 102.876C188.513 94.8421 193.325 88.0888 199.841 83.0084C200.367 82.5954 200.904 82.1927 201.452 81.8003C208.215 76.9986 216.6 73.8905 225.728 72.8476C230.468 72.3106 235.404 72.3312 240.422 72.9611C243.551 73.3535 246.711 73.9938 249.871 74.8715C261.405 78.0932 271.194 84.1546 278.329 91.7959C280.074 93.6546 281.654 95.5959 283.059 97.6198C287.963 104.642 290.834 112.551 291.103 120.595V123.394L291.113 123.383ZM291.113 123.383C291.134 122.919 291.144 122.454 291.144 121.989M271.679 121.163V119.387C271.514 114.286 269.686 109.268 266.578 104.817C265.69 103.537 264.688 102.308 263.584 101.131C259.061 96.2878 252.855 92.4465 245.544 90.4019C243.541 89.8443 241.537 89.4416 239.555 89.1937C236.364 88.791 233.235 88.7807 230.23 89.1215C224.437 89.7823 219.13 91.7546 214.834 94.8008C214.483 95.0486 214.142 95.3068 213.812 95.5649C209.671 98.7867 206.625 103.072 205.2 108.163C201.059 123.032 212.377 139.182 230.509 144.242C248.631 149.302 266.692 141.361 270.843 126.492C271.338 124.736 271.607 122.95 271.679 121.174V121.163ZM271.679 121.163C271.679 120.864 271.7 120.575 271.7 120.275C271.7 120.575 271.7 120.864 271.679 121.163Z",
    stroke: "black",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M251.52 158.069L241.36 158.209L241.726 184.745L251.885 184.605L251.52 158.069Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M248.928 183.564L244.663 183.623L245.427 239.027L249.692 238.968L248.928 183.564Z",
    stroke: "black",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M217.953 162.406L213.358 160.196L170.587 215.172L173.943 217.805L217.953 162.406Z",
    stroke: "black",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M245.503 246.264H271.69L250.077 238.117H245.41L245.503 246.264Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M168.78 224.569L147.818 208.863L170.009 215.307L173.736 218.105L168.78 224.569Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M141.209 39.8354H98.4591C96.1323 39.8354 94.2461 41.7217 94.2461 44.0485V98.312C94.2461 100.639 96.1323 102.525 98.4591 102.525H141.209C143.536 102.525 145.422 100.639 145.422 98.312V44.0485C145.422 41.7217 143.536 39.8354 141.209 39.8354Z",
    stroke: "#4767FF",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M123.128 47.4766H137.75",
    stroke: "#4767FF",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M125.286 55.3452H137.75",
    stroke: "#4767FF",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M121.982 63.2134H137.75",
    stroke: "#4767FF",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M101.774 71.082H137.75",
    stroke: "#4767FF",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M101.774 78.9507H137.75",
    stroke: "#4767FF",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M101.774 86.8193H137.75",
    stroke: "#4767FF",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M101.774 94.687H137.75",
    stroke: "#4767FF",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M108.951 63.2445C114.095 63.2445 118.265 59.0744 118.265 53.9303C118.265 48.7863 114.095 44.6162 108.951 44.6162C103.807 44.6162 99.6365 48.7863 99.6365 53.9303C99.6365 59.0744 103.807 63.2445 108.951 63.2445Z",
    stroke: "#4767FF",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M108.95 52.9704C110.308 52.9704 111.408 51.8701 111.408 50.5128C111.408 49.1555 110.308 48.0552 108.95 48.0552C107.593 48.0552 106.493 49.1555 106.493 50.5128C106.493 51.8701 107.593 52.9704 108.95 52.9704Z",
    fill: "#4767FF"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M108.95 58.0918C110.417 58.0918 111.831 58.195 113.163 58.3809C113.762 58.4635 114.289 57.9575 114.196 57.3689C113.742 54.6429 111.573 52.5776 108.961 52.5776C106.348 52.5776 104.169 54.6429 103.725 57.3689C103.622 57.9678 104.159 58.4738 104.758 58.3809C106.08 58.195 107.494 58.0918 108.971 58.0918H108.95Z",
    fill: "#4767FF"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M280.146 119.181C267.528 119.181 252.349 117.281 234.856 113.512C182.844 102.298 147.436 80.2723 145.959 79.3429L154.406 65.9087C154.746 66.1255 189.07 87.4076 238.202 98.0021C259.019 102.494 275.995 104.146 288.676 102.938C298.331 102.009 305.301 99.3962 308.853 95.369C313.376 90.2369 312.033 82.6266 310.102 77.1435L325.075 71.8772C329.794 85.2804 328.256 97.3516 320.759 105.86C314.408 113.068 304.124 117.395 290.194 118.737C287.055 119.036 283.699 119.191 280.146 119.191V119.181Z",
    stroke: "black",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M217.994 92.8595C221.629 90.9182 225.78 89.6378 230.22 89.1318C233.225 88.791 236.354 88.8013 239.544 89.2041C241.527 89.4519 243.53 89.8546 245.533 90.4122C252.844 92.4568 259.05 96.2981 263.573 101.141C263.965 101.554 264.337 101.988 264.699 102.411C272.856 103.289 280.095 103.526 286.373 103.113C285.402 101.234 284.287 99.3959 283.048 97.6198C281.644 95.5959 280.064 93.6546 278.319 91.7959C271.183 84.1546 261.394 78.0932 249.86 74.8715C246.7 73.9938 243.54 73.3535 240.412 72.9611C235.393 72.3312 230.457 72.3106 225.718 72.8476C216.589 73.8905 208.205 76.9986 201.441 81.8003C200.894 82.1927 200.357 82.5954 199.83 83.0084C198.725 83.8758 197.672 84.7845 196.67 85.7448C203.196 88.1921 210.332 90.6084 217.994 92.8492V92.8595Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M291.103 120.596C291.082 119.945 291.03 119.295 290.979 118.644C290.721 118.675 290.462 118.696 290.194 118.727C287.055 119.026 283.699 119.181 280.147 119.181C277.431 119.181 274.591 119.088 271.648 118.913C271.648 119.078 271.669 119.243 271.679 119.408V121.184C271.679 120.885 271.7 120.596 271.7 120.296C271.7 120.596 271.7 120.885 271.679 121.184C271.607 122.96 271.338 124.747 270.843 126.502C266.692 141.372 248.631 149.313 230.509 144.253C212.377 139.193 201.059 123.043 205.2 108.173C205.427 107.368 205.696 106.573 206.005 105.809C199.366 103.692 193.17 101.482 187.48 99.2827C187.016 100.46 186.603 101.658 186.262 102.887C179.725 126.337 197.59 151.811 226.183 159.783C254.765 167.765 283.255 155.229 289.791 131.789C290.566 129.011 290.999 126.203 291.113 123.394V120.596H291.103Z",
    fill: "black"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M271.679 121.184V119.408C271.669 119.243 271.648 119.078 271.648 118.913C274.591 119.088 277.431 119.181 280.147 119.181C283.699 119.181 287.055 119.026 290.194 118.727C290.462 118.696 290.721 118.675 290.979 118.644C291.03 119.295 291.082 119.945 291.103 120.596H291.113V123.394M271.679 121.184C271.679 120.885 271.7 120.596 271.7 120.296C271.7 120.596 271.7 120.885 271.679 121.184ZM271.679 121.184C271.607 122.96 271.338 124.747 270.843 126.502C266.692 141.372 248.631 149.313 230.509 144.253C212.377 139.193 201.059 123.043 205.2 108.173C205.427 107.368 205.696 106.573 206.005 105.809C199.366 103.692 193.17 101.482 187.48 99.2827C187.016 100.46 186.603 101.658 186.262 102.887C179.725 126.337 197.59 151.811 226.183 159.783C254.765 167.765 283.255 155.229 289.791 131.789C290.566 129.012 290.999 126.203 291.113 123.394M291.113 123.394C291.134 122.929 291.144 122.465 291.144 122",
    stroke: "black",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M308.615 64.2049C308.584 65.2685 307.252 68.6348 310.887 67.375C314.625 66.0842 316.525 60.3739 316.401 58.1951C316.246 55.6239 312.818 54.8598 309.896 59.5891C306.973 64.3185 304.681 58.856 307.882 54.3538C310.66 50.4505 315.069 49.6038 317.743 51.1321C320.676 52.8049 320.242 55.5516 319.984 58.7217C319.984 58.7217 323.609 47.7554 326.324 48.5299C329.04 49.294 323.66 60.4152 323.66 60.4152C323.66 60.4152 328.576 51.0495 330.579 52.1337C332.572 53.2179 326.696 62.9348 326.696 62.9348C326.696 62.9348 330.073 57.7304 331.746 59.4549C333.418 61.1793 323.423 71.9288 323.423 71.9288L310.732 76.2244C310.732 76.2244 303.359 72.3831 303.049 67.7157C302.657 61.9125 308.739 59.0212 308.605 64.1946L308.615 64.2049Z",
    fill: "black"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M154.943 64.845C154.943 64.845 144.823 51.0494 141.385 50.8635C137.946 50.6777 139.856 56.0885 144.803 63.2445L144.575 77.0711C145.319 78.8679 145.949 79.3325 145.949 79.3325L154.932 64.845H154.943Z",
    fill: "black"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M334.142 74.5413L342 76.2658L339.759 68.2424H349.465L342 58.7734L371.171 54.5501L343.796 43.1294L353.348 36.1283L339.315 33.743L350.364 13.5762L328.751 27.7126L321.637 13.5762L311.342 26.4734L287.953 22.5392L302.172 36.0251L287.953 38.3794L295.543 43.1294L282.108 50.1718L296.152 56.6566L292.28 63.4615L299.487 62.8419",
    stroke: "#4767FF",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEmptyStateDocuments);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/EmptyStateDocuments.a6a5cde3221231cc4876aa5be028d1da.svg";